import React from 'react';
import PaymentForm from '../../components/PaymentForm';
import styled from 'styled-components';
import TopBar from '../../components/TopBar';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 20px; // Padding to avoid content sticking to edges
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 860px;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); // Subtle shadow for separation
  box-sizing: border-box;
  margin-top: 20px; // Spacing between the TopBar and content
`;

const Title = styled.h1`
  color: #edf4ff; // Title color to match the other pages
  text-align: center;
  margin-bottom: 20px;
`;

const PaymentPage = () => {
  const handlePayment = (paymentMethod) => {
    // Handle payment logic here
    console.log('Received paymentMethod:', paymentMethod);
  };

  return (
    <PageContainer>
      <TopBar />
      <ContentWrapper>
        <Title>Please choose your payment plan</Title>
        <PaymentForm handlePayment={handlePayment} />
      </ContentWrapper>
    </PageContainer>
  );
};

export default PaymentPage;
